import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

function ManageQuotes() {

    const navigate = useNavigate()
    const [quotes, setQuotes] = useState([])
    const backendUrl = process.env.REACT_APP_BACKEND_URI

    useEffect(() => {
        const token = localStorage.getItem('adminToken')
        if (!token) {
            navigate('/')
        } else {
            const fetchQuotes = async () => {
                const res = await axios.get(`${backendUrl}/api/quote`)
                setQuotes(res.data)
            }
            fetchQuotes()
        }
    }, [navigate, backendUrl])

    const deleteAllQuotes = async () => {
        if (!window.confirm("Are you sure you want to delete ALL quotes?")) return;

        await axios.delete(`${backendUrl}/api/quote`)
        setQuotes([])
    }

    return (
        <div className="admin-page">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Manage Quotes</h2>

                <button
                    className="danger-btn"
                    onClick={deleteAllQuotes}
                >
                    Delete All
                </button>
            </div>

            <table className="admin-table" style={{ textAlign: 'center' }}>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Product</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Application</th>
                        <th>Message</th>
                    </tr>
                </thead>

                <tbody>
                    {quotes.length === 0 ? (
                        <tr>
                            <td colSpan="7">No quotes found</td>
                        </tr>
                    ) : (
                        quotes.map(q => (
                            <tr key={q._id}>
                                <td>{new Date(q.createdAt).toLocaleDateString()}</td>
                                <td>{q.productName}</td>
                                <td>{q.name}</td>
                                <td>{q.email}</td>
                                <td>{q.phone}</td>
                                <td>{q.application}</td>
                                <td>{q.message}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div >
    )
}

export default ManageQuotes
